<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Unit" subTitle="Forms" />

    <CreateUnit />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateUnit from "@/components/Pages/Master/Unit/CreateUnit.vue";

export default defineComponent({
  name: "CreateUnitPage",
  components: {
    PageTitle,
    CreateUnit,
  },
});
</script>
